var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[(
      _vm.wpPageId === 1808 
    )?[_c('Splash',{attrs:{"acf":_vm.acf,"id":_vm.wpPageId}}),_c('div',{staticClass:"backgroundImage"}),_c('div',{staticClass:"container"},[_c('p',{staticClass:"enterpriseParagraph",domProps:{"innerHTML":_vm._s(_vm.acf.content.rendered)}})])]:_vm._e(),_c('Footer')],2)
}
var staticRenderFns = []

export { render, staticRenderFns }